import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { useMemoOne as useMemo } from 'use-memo-one';

export type EmbeddedMacroType = 'UIKit' | 'CustomUI';

/**
 * Contributes embedded macro attributes to `forgeUIAttributes` for every Forge UI
 * analytics event fired by descendant components.
 */
export const ForgeUIEmbeddedMacroAnalyticsContext = ({
	contentId,
	embeddedMacroParentType,
	embeddedMacroType,
	children,
}: {
	children: React.ReactNode;
	contentId: string | undefined;
	embeddedMacroParentType: EmbeddedMacroType;
	embeddedMacroType: EmbeddedMacroType;
}): React.JSX.Element => {
	const data = useMemo(
		() => ({
			forgeUIAttributes: {
				contentId,
				isEmbeddedMacro: true,
				embeddedMacroParentType,
				embeddedMacroType,
			},
		}),
		[contentId, embeddedMacroParentType, embeddedMacroType],
	);

	return <AnalyticsContext data={data}>{children}</AnalyticsContext>;
};
